import { css } from "emotion";
import { InterpolationWithTheme } from "@emotion/core";
import {colors} from "../../colors";

export const TherapistPastSessionsStyles: {[key: string]: any} = {
    panelContainer: {
        border: "1px solid rgb(234, 234, 234)",
        background: colors.lightGrey,
        borderRadius: 5,
        marginBottom: 20
    },
    header: {
        cursor: "pointer",
        color: colors.slateBlue,
        fontFamily: "BrandonTextWeb-Bold",
        padding: "10px 15px"
    },
    panelBody: {
        padding: 15
    },
    subHeader: {
        color: "#2c2c2c",
        marginBottom: 15,
        fontSize: 16,
        fontFamily: "BrandonTextWeb-Medium"
    },
    bodyText: {
        color: "#666666",
        fontSize: 14
    },
    row: {
        display: "flex"
    },
    col: {
        flex: 1
    },
    colHeader: {
        flex: 1,
        color: colors.slateBlue,
        fontFamily: "BrandonTextWeb-Medium"
    },
    subContainer: {
        padding: "15px 0",
        borderBottom: "1px solid #eaeaea"
    }
}